var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-4 ml-3 d-flex justify-content-between" },
    [
      _c(
        "span",
        { staticClass: "pagination-info", class: { hidden: !_vm.showText } },
        [
          _vm._v(
            " Mostrando " +
              _vm._s(_vm.startIndex) +
              " al " +
              _vm._s(_vm.endIndex) +
              " de " +
              _vm._s(_vm.total) +
              " resultados "
          )
        ]
      ),
      _c(
        "ul",
        { staticClass: "pagination mr-3 d-flex flex-wrap" },
        [
          _vm.currentPage > _vm.pageButtonCount - _vm.pageButtonOffset
            ? _c("li", { staticClass: "mr-2 bg-light-gray" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goToPage(1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-chevron-double-left" })]
                )
              ])
            : _vm._e(),
          _vm.currentPage > 1
            ? _c("li", { staticClass: "mr-2 bg-light-gray" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goToPage(_vm.currentPage - 1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-chevron-left" })]
                )
              ])
            : _vm._e(),
          _vm._l(_vm.pages, function(page, index) {
            return _c(
              "li",
              {
                key: page,
                staticClass: "custom-border border-top border-bottom p-page",
                class: {
                  first: index === 0,
                  last: index === _vm.pages.length - 1,
                  active: page === _vm.currentPage
                }
              },
              [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goToPage(page)
                      }
                    }
                  },
                  [_vm._v(_vm._s(page))]
                )
              ]
            )
          }),
          _vm.currentPage < _vm.data.pageCount
            ? _c("li", { staticClass: "ml-2" }, [
                _c(
                  "a",
                  {
                    staticClass: "bg-light-gray",
                    on: {
                      click: function($event) {
                        return _vm.goToPage(_vm.currentPage + 1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-chevron-right" })]
                )
              ])
            : _vm._e(),
          _vm.currentPage < _vm.data.pageCount - _vm.pageButtonOffset
            ? _c("li", { staticClass: "ml-2" }, [
                _c(
                  "a",
                  {
                    staticClass: "bg-light-gray",
                    on: {
                      click: function($event) {
                        return _vm.goToLastPage()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-chevron-double-right" })]
                )
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }